import CustomQuill from 'quill/core';

import Toolbar from 'quill/modules/toolbar';
import Snow from 'quill/themes/snow';

import Bold from 'quill/formats/bold';
import Italic from 'quill/formats/italic';
import Underline from 'quill/formats/underline';
import Header from 'quill/formats/header';
import Link from 'quill/formats/link';
import List from 'quill/formats/list';
import { ListItem } from 'quill/formats/list';
import {ColorStyle} from "quill/formats/color";
import {BackgroundStyle} from "quill/formats/background";
import {FontStyle} from "quill/formats/font";
import Image from "quill/formats/image";
import { ADMBlot } from "./ADMBlot";
import { ReadMore } from "./ReadMoreBlot";

CustomQuill.register({
    'modules/toolbar': Toolbar,
    'themes/snow': Snow,
    'formats/bold': Bold,
    'formats/italic': Italic,
    'formats/underline': Underline,
    'formats/header': Header,
    'formats/link': Link,
    'formats/list-item': ListItem,
    'formats/list': List,
    'formats/image': Image,
    'formats/readMore': ReadMore,

    // necessary for ADM Variable display in the editor
    'formats/color': ColorStyle,
    'formats/background': BackgroundStyle,
    'formats/font': FontStyle,
});

CustomQuill.register(ADMBlot);

export default CustomQuill;
